import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { GTM_DISPLAY_BULK_FEATURE } from '@/domains/productDiscovery/ProductPage/common/modules/BulkPurchase/tracking/gtmEvents';

interface UseBulkPurchaseTableTrackingInput {
  selectedIndex: number;
  hasCoupon: boolean;
}

export const useBulkPurchaseTableTracking = ({
  selectedIndex,
  hasCoupon,
}: UseBulkPurchaseTableTrackingInput) => {
  const { ref, inView } = useInView({ threshold: 0.75 });

  useEffect(() => {
    if (inView) {
      Gtm.push(GTM_DISPLAY_BULK_FEATURE(selectedIndex, hasCoupon));
    }
  }, [inView, hasCoupon, selectedIndex]);

  return ref;
};
